import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHyperlink2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "hyperlink-2" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 6.75,
			y1: 17.249,
			x2: 17.25,
			y2: 6.749
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M7.735,12.021a4.472,4.472,0,0,0-3.417,1.3l-2.25,2.25a4.5,4.5,0,0,0,6.364,6.364l2.25-2.25a4.472,4.472,0,0,0,1.3-3.417"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M16.265,11.976a4.473,4.473,0,0,0,3.417-1.3l2.25-2.25a4.5,4.5,0,0,0-6.364-6.364l-2.25,2.25a4.475,4.475,0,0,0-1.295,3.417"
		})
	]
});
export default SvgHyperlink2;
